import { isAxiosError } from 'axios';
import { axiosAuth } from '@/axios';
import { User } from '@/types/auth';
import { Endpoints } from '@/enums';

export type UserCredentials = {
  username: string;
  password: string;
};

export const sendUsernameAndPassword = async ({
  username,
  password,
}: UserCredentials): Promise<User> => {
  try {
    const res = await axiosAuth.post<User>(Endpoints.Login, {
      username,
      password,
    });
    return res.data;
  } catch (error) {
    // El cliente quiere mostrar el body de error en un mensaje
    if (isAxiosError(error)) {
      const backendMessage =
        error.response?.data?.message || error.response?.data || error.message;
      throw new Error(
        typeof backendMessage === 'string'
          ? backendMessage
          : JSON.stringify(backendMessage)
      );
    }
    throw error;
  }
};
